module.exports = __webpack_public_path__ + "static/media/isel.d23514f4.png";